import { render, staticRenderFns } from "./LinkToSettings.vue?vue&type=template&id=62120073&scoped=true&"
import script from "./LinkToSettings.vue?vue&type=script&lang=js&"
export * from "./LinkToSettings.vue?vue&type=script&lang=js&"
import style0 from "./LinkToSettings.vue?vue&type=style&index=0&id=62120073&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62120073",
  null
  
)

export default component.exports